<!-- 实物到店自提不预约 -->
<template>
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false"
        :overlayStyle="overlayStyle">
        <div class="diyModal">
            <!-- 虚拟线下核销发卡密专用 -->
            <div v-if="awardObj.collectionType === '3'">
              <div v-if="usedFlag !== '4'" class="awardContent">
                <!-- 未核销 -->
                  <div class="virtualOnline">线下门店核销码</div>
                  <div class="imgCode">
                      <van-image width="160"
                          height="160"
                          :src="`data:image/png;base64,${codeUrl}`" />
                  </div>
                  <div class="writeOffCode">{{writeOffCode}}</div>
                  <div v-if="effectiveEndTime && effectiveStartTime"
                      class="voucherDate">有效期：{{startTime}}-{{endTime}}</div>
                  <div class="buttonText">
                      <van-button class="vanButtonText"
                          round
                          type="info"
                          @click="modalOk">领取卡密</van-button>
                  </div>
              </div>
              <div v-else class="awardContent">
                <!-- 已核销 -->
                <div class="virtualOnline">恭喜您获得卡密</div>
                <div class="copy">请截图或复制使用</div>
                <div class="activationCode">{{activationCode}}</div>
                <div class="buttonText">
                  <van-button v-clipboard:copy="awardObj.activationCode"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    class="copyButtonText"
                    plain round type="info">复制卡密</van-button>
                </div>
              </div>
            </div>
            <!-- 线下核销不暂时卡密 -->
            <div v-else>
              <div class="awardContent">
                  <div class="virtualOnline">线下门店核销码</div>
                  <div class="imgCode">
                      <van-image width="160"
                          height="160"
                          :src="`data:image/png;base64,${codeUrl}`" />
                  </div>
                  <div class="writeOffCode">{{writeOffCode}}</div>
                  <div v-if="effectiveEndTime && effectiveStartTime"
                      class="voucherDate">有效期：{{startTime}}-{{endTime}}</div>
                  <div class="buttonText">
                      <van-button class="vanButtonText"
                          round
                          type="info"
                          @click="modalOk">确定</van-button>
                  </div>
              </div>
            </div>
            <div class="diyClose"
                @click="modalCancel(true)">
                <van-icon name="close" />
            </div>
        </div>
    </van-dialog>
</template>

<script>
/**
 * 实物+到店自提，虚拟+线下核销发卡密，虚拟+线下核销 
 * 分为未核销和已核销两部分，未核销展示用来核销的二维码，已核销展示卡密。
 * 用usedFlag区分当usedFlag为4时则已核销
 * usedFlag 使用标识 (0.未领取,1.已领取,2.待领取,3.已预约,4.已核销,5.已免单,6.已过期")
 * rewardType为1，collectionType为3则为虚拟线下核销发卡密，领取按钮需要进行查询是否核销，具体操作如下
 * modalOk方法-this.$emit('getUsedFlag')-在父组件中调用接口如果返回true则手动将awardObj.usedFlag变为4即可，false则提示他未核销
 */
import { Icon, Dialog, Toast, Button, Image } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Image.name]: Image,
  },
  props: {
    overlayStyle: Object, // 弹窗样式
    goodsIndex: Number,//领取的权益品的index-为了抛出入参时在父组件进行领取状态更改
    awardObj: Object, // 中奖信息的Obj
    codeUrl: String, // 核销码url base64格式
    writeOffCode: String, // 核销码
    effectiveStartTime: String, // 有效开始时间
    effectiveEndTime: String, // 有效结束时间
    extendConfigFlag:Boolean, // 是否核销,除虚拟线下发卡密场景使用此字段，目前无用
    activationCode:String // 卡密编码
  },
  data() {
    return {
      isVisibility: true,
      usedFlag: 0
    };
  },
  computed: {
    startTime(){
      if(this.effectiveStartTime){
        return this.effectiveStartTime.slice(0,10).replace(/-/g,"/")
      }
      return ''
    },
    endTime(){
      if(this.effectiveEndTime){
        return this.effectiveEndTime.slice(0,10).replace(/-/g,"/")
      }
      return ''
    }
  },
  created(){
    this.usedFlag = this.awardObj.usedFlag
  },
  methods: {
    modalOk() {
      console.log('code-cancel-after-verification===>this.awardObj', this.awardObj);
      let url = ''
      if (this.awardObj.exchangeGoodsVOList) {
        url = this.awardObj.exchangeGoodsVOList[this.goodsIndex].jumpUrl
      }
     
      if(this.awardObj.collectionType === '3'){
        this.getUsedFlag() // 虚拟线下发卡密需判断是否核销
      }else{
        this.$emit('refreshTaskList'); // 签到，刷新任务列表
        this.$emit('nextStep'); // 跳转配置用到，不用父组件则不加
        setTimeout(() => {
          this.modalCancel()
          this.$emit('getExchangeGoodsToUrl',url)
        }, 500);
        
      }
      
    },
    modalCancel() {
      this.$emit('closeEnd');
    },
    onCopy() {
      Toast('复制成功！');
      let url = ''
      if (this.awardObj.exchangeGoodsVOList) {
        url = this.awardObj.exchangeGoodsVOList[this.goodsIndex].jumpUrl
      }
      setTimeout(() => {
        this.$emit('nextStep') // 跳转配置用到，不用父组件则不加
        this.$emit('getExchangeGoodsToUrl',url)
      }, 1000);
    },
    onError() {
      Toast('复制失败！');
      setTimeout(() => {
        this.$emit('nextStep') // 跳转配置用到，不用父组件则不加
      }, 1000);
    },
    // 虚拟线下核销发卡密查询是否核销
    getUsedFlag(){
      this.$api.post({
          sc: "mobileMarketing",
          url: `h5/bigWheel/queryWriteOffStatusById/${this.awardObj.exchangeActivationCodeId}`,
          params:{},
          success: r => {
            if(r.result){
              this.usedFlag = '4'
              this.$emit('queryStatus',this.awardObj)
              this.$emit('getUsedFlag')
              this.usedFlag = '4';
            }else{
              Toast('暂未核销，核销后可查看卡密')
            }
          },
          failure:() => {
              Toast('领取失败！');
          }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .diyModal {
      width: 320px;
      height: auto;
      margin: auto;
      min-height: 245px;
      position: relative;
      z-index: 10;
      .awardContent {
        width: 95%;
        min-height: 105px;
        padding-bottom: 16px;
        margin: 0 2.5%;
        background-image: linear-gradient(180deg, #ffffff 0%,#f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
        text-align: center;
        border-radius: 20px;
        margin-top: 20px;
        .virtualOnline {
          font-size: 21px;
          font-weight: 900;
          padding: 26px 0 0;
          color: #000;
        }
        .awardName {
          color: #000;
          font-size: 20px;
          padding: 26px 10px 0;
          text-align: center;
        }
        .ellipsis {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .imgCode {
          width: 160px;
          height: 160px;
          overflow: hidden;
          margin: 13px auto 0;
        }
        .writeOffCode {
          margin-top: 15px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #29231e;
        }
        .voucherDate {
          font-size: 12px;
          color: #29231e;
          text-align: center;
          font-weight: 400;
        }
        .buttonText {
          width: 77%;
          margin: 24px auto 0;
          .vanButtonText {
            width: 100%;
            font-size: 16px;
            background: #256fff;
          }
          .copyButtonText{
            width: 100%;
            font-size: 16px;
            background: rgba(0,0,0,0);
          }
        }
        .copy{
          font-size: 16px;
          color: #999999;
          text-align: center;
          font-weight: 400;
          margin-top: 5px;
        }
        .activationCode{
          font-size: 24px;
          color: #000000;
          text-align: center;
          font-weight: 500;
          margin: 52px 0 70px;
          word-break: break-all;
          padding: 0 30px;
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -32px;
        z-index: 10000;
        color: #ffffff;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/code-cancel-after-verification.vue